import Vue from 'vue'
import Router from 'vue-router'
import Index from '../components/Index'
import ContactUs from '../components/ContactUs'
import AboutUs from '../components/AboutUs'
import Ecommerce from '../components/Ecommerce'
import OnlineCar from '../components/OnlineCar'
Vue.use(Router)


// {
//     path: '/onlineCar',
//     name: 'OnlineCar',
//     component: OnlineCar
// },

export default new Router({
    routes: [
        {
            path: '/',
            name: 'Index',
            component: OnlineCar
        },
        // {
        //     path: '/contactUs',
        //     name: 'ContactUs',
        //     component: ContactUs
        // },
        // {
        //     path: '/aboutUs',
        //     name: 'AboutUs',
        //     component: AboutUs
        // },
        // {
        //     path: '/ecommerce',
        //     name: 'Ecommerce',
        //     component: Ecommerce
        // },
        // {
        //     path: '/onlineCar',
        //     name: 'OnlineCar',
        //     component: OnlineCar
        // },
    ]
})
